import React from 'react'
import { Select, Table } from 'antd'
import equal from 'fast-deep-equal'

import { Permission, Group } from './PermissionsTypes'
import I18n from '../../i18n';

type PropsType = {
  permissions: Array<Permission>,
  groups: Array<Group>,
  currentGroup: Group,
  onChangePermission: any,
  finalPermissions: any,
  onCreateInitialPermissionsObject: any,
  currentPermissions: any,
  getCurrentPermissionValue: any,
  gridKey: any
}

const { Option } = Select;

class PermissionsGrid extends React.Component<PropsType, any> {
  constructor (props: PropsType) {
    super(props)
    this.state = {
      update: false
    }

    this.createGroupsRows = this.createGroupsRows.bind(this)
    this.createTableRows = this.createTableRows.bind(this)
    this.createGroupsColumns = this.createGroupsColumns.bind(this)
    this.createTableColumns = this.createTableColumns.bind(this)
    this.renderGroupPermissions = this.renderGroupPermissions.bind(this)
  }

  componentDidMount () {
    this.props.onCreateInitialPermissionsObject()
  }

  componentDidUpdate(prevProps: any) {
    if (!equal(this.props.currentPermissions, prevProps.currentPermissions)) {
      this.setState({ update: true }, () => {
        this.setState({ update: false })
      })
    }
  } 

  t (field: String) {
    return I18n.l("permissions.createGroupModal.type." + field)
  }

  createGroupsRows (permission: any) {
    const { currentGroup, groups } = this.props
    const availableGroups = currentGroup.id ? groups.filter(r => r.id !== currentGroup.id) : groups

    return availableGroups.map(r => {
      const keyName = `group-${r.id}`
      return { [keyName]: this.renderGroupPermissions(permission, r) }
    })
  }

  createTableRows () {
    const rows = this.props.permissions.map(r => {
      const groups = this.createGroupsRows(r).values()
      let finalRow = {
        key: r.name,
        permissions: this.t(r.name),
        currentGroup: this.renderGroupPermissions(r, this.props.currentGroup)
      }

      for (let g of groups) {
        finalRow = { ...finalRow, ...g}
      }

      return finalRow
    })

    return rows
  }

  createGroupsColumns () {
    const { currentGroup, groups } = this.props
    const availableGroups = currentGroup.id ? groups.filter(r => r.id !== currentGroup.id) : groups

    return availableGroups.map(r => {
      const title = r.name
      const dataIndex = `group-${r.id}`
      return { title, dataIndex }
    })
  }

  createTableColumns(): any {
    const groupsArray = this.createGroupsColumns()
    const colsArray: any = [
      { title: I18n.l('permissions'), dataIndex: 'permissions' },
      { title: this.props.currentGroup.name, dataIndex: 'currentGroup' }
    ]

    return [...colsArray, ...groupsArray]
  }

  renderGroupPermissions(permission: any, group: Group) {
    const className = group.id ? 'group' : 'current-group'
    return (
      <Select
        className={`permission-select ${className}-${permission.name}`}
        onChange={(e: any) => this.props.onChangePermission(permission.id, e, group.id)}
        defaultValue={this.props.getCurrentPermissionValue(permission.id, group.id)}
      >
        <Option value={1}>{I18n.l('permissions.createGroupModal.optionAll')}</Option>
        <Option value={2}>{I18n.l('permissions.createGroupModal.optionMine')}</Option>
        <Option value={3}>{I18n.l('permissions.createGroupModal.optionNone')}</Option>
      </Select>
    )
  }

  render() {
    const { update } = this.state
    const { gridKey } = this.props

    return (<>
    {!update && <Table
      key={gridKey}
      columns={this.createTableColumns()}
      dataSource={this.createTableRows()}
      pagination={false}
    />}
    </>)
  }
}

export default PermissionsGrid